import gql from 'graphql-tag';

export const GET_INSTALLED_AFFILIATE_STORE_APP_BY_DOMAIN = gql`
  query getInstalledAffiliateStoreAppByDomain($input: GetInstalledAffiliateStoreAppInput!) {
    getInstalledAffiliateStoreAppByDomain(input: $input) {
      id
      configs {
        key
        value
      }
      affiliateStoreApp {
        name
      }
      requirements {
        # id
        value
        required
        active
        unique
        additionalFields
      }
      active
    }
  }
`;

export type getInstalledAffiliateStoreAppByDomainInput = {
  input: {
    id: string;
  };
};

export type getInstalledAffiliateStoreAppByDomainQuery = {
  getInstalledAffiliateStoreAppByDomain: IInstalledApps;
};
